import React from 'react';

import carveConfirmationImgPath from 'assets/pngs/carve-confirmation.png';
import { Button } from 'ui-kit';

interface CreateCarveQuestionProps {
  setCreateCarve: (value: boolean) => void;
  onNoCarve: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const CreateCarveQuestion: React.FC<CreateCarveQuestionProps> = ({ setCreateCarve, onNoCarve }) => {
  return (
    <div className="mt-5 flex flex-col items-center">
      <img src={carveConfirmationImgPath} alt="Create Carve Icon" />
      <div className="mx-0 mb-30px mt-2.5 font-heebo text-2xl font-medium leading-9 text-slate-400">
        Would you like to create a carve of the offering?
      </div>
      <div className="flex flex-row gap-10">
        <Button onClick={onNoCarve} type="secondary" label={'No'}>
          No
        </Button>
        <Button onClick={() => setCreateCarve(true)} label={'Yes'}>
          Yes
        </Button>
      </div>
    </div>
  );
};

export default CreateCarveQuestion;
